import { render, staticRenderFns } from "./DdianConf.vue?vue&type=template&id=2633fabd&scoped=true"
import script from "./DdianConf.vue?vue&type=script&lang=js"
export * from "./DdianConf.vue?vue&type=script&lang=js"
import style0 from "./DdianConf.vue?vue&type=style&index=0&id=2633fabd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2633fabd",
  null
  
)

export default component.exports